import { Link, useLocation } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-2">
          {i > 0 && <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>}
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-600 transition-colors duration-200">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}